
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nseb9e45356590c93e36cee0757ef605d6en from './en.yaml'
            i18n.addResourceBundle('en', 'eb9e45356590c93e36cee0757ef605d6', flattenObject(nseb9e45356590c93e36cee0757ef605d6en), true, true);
        
        export default 'eb9e45356590c93e36cee0757ef605d6';
    